import { useInfiniteQuery } from 'react-query';

import { PaginatedApiCollectionResponse } from 'types/api_response';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { ManualSearchResult } from 'views/App/Portal/Policy/_types/search';

export default function useIssuedManualSearch<T extends ManualSearchResult>(
  search: string,
  params = {},
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/search/v1/manuals/issued/awb`;

  return useInfiniteQuery<PaginatedApiCollectionResponse<T>, Error>(
    ['issued_manual_search_awb', search, params],
    async ({ pageParam, signal }): Promise<PaginatedApiCollectionResponse<T>> => {
      // Return empty results if search is empty
      if (!search) {
        return {
          content: [],
          count: 0,
          nextToken: undefined,
        };
      }

      const paramString = new URLSearchParams(
        Object.entries({
          ...params,
          search,
        })
          // eslint-disable-next-line no-unused-vars
          .filter(([_k, v]) => v != null)
          .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
      ).toString();
      const data: PaginatedApiCollectionResponse<T> = await fetcher({
        method: 'get',
        url: pageParam || `${url}?${paramString}`,
        options: { signal },
      });

      return data as PaginatedApiCollectionResponse<T>;
    },
    {
      ...options,
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (lastPage.nextToken && lastPage.content.length > 0) {
          const paramString = new URLSearchParams(
            Object.entries({
              ...params,
              search,
              nextToken: lastPage.nextToken,
            })
              // eslint-disable-next-line no-unused-vars
              .filter(([_k, v]) => v != null)
              .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
          ).toString();

          return `${url}?${paramString}`;
        }
        return undefined;
      },
    }
  );
}
